export const CUSTOMER_LOGIN_REQUEST = 'CUSTOMER_LOGIN_REQUEST'
export const CUSTOMER_LOGIN_SUCCESS = 'CUSTOMER_LOGIN_SUCCESS'
export const CUSTOMER_LOGIN_FAIL = 'CUSTOMER_LOGIN_FAIL'
export const CUSTOMER_LOGOUT = 'CUSTOMER_LOGOUT'

export const CUSTOMER_REGISTER_REQUEST = 'CUSTOMER_REGISTER_REQUEST'
export const CUSTOMER_REGISTER_SUCCESS = 'CUSTOMER_REGISTER_SUCCESS'
export const CUSTOMER_REGISTER_FAIL = 'CUSTOMER_REGISTER_FAIL'

export const SET_CODEC = "SET_CODEC";